<template>
  <div class="">
    <h5 class="d-inline-block" v-if="user">
      کاربر:
      {{ `${user.name} ${user.last_name}` }}
    </h5>
    <b-row class="d-print-none">
      <b-col cols="12" lg="12" class="text-right">
        <b-btn v-if="isUserHaveAccess" class="mx-2" variant="primary" v-b-toggle.create-loan pill>ایجاد قسط جدید</b-btn>
        <m-a target="_blank" :href="{ name: 'Factor', params: { orderId: $route.params.order } }">
          <b-btn class="mx-2" variant="primary" pill>مشاهده فاکتور سفارش</b-btn>
        </m-a>

          <b-icon class="h2 p-0 m-0" @click="manageLoanPrint()" icon="printer-fill"></b-icon>

        <b-collapse id="create-loan" class="mt-2">
          <loan-create-form :order_id="$route.params.order" class="col-lg-12 my-4"/>
        </b-collapse>
      </b-col>
    </b-row>
    <b-table v-bind="tableAttributes" :items="loanItems" :fields="fields">

      <template #cell(date_of_payment)="data">
        <span dir="ltr" class="text-wrap">{{ dateConverter(data.item.date_of_payment, '/', true) }}</span>
      </template>

      <template #cell(value)="data">
        <span class="text-wrap">{{ formatNumber(data.item.value) }}</span>
      </template>

      <template #cell(transaction)="data">
        <m-a target="_blank" v-if="isLoanPaid(data.item)"
             :href="{name:'verifyTransaction',params:{slug:data.item.transaction.slug}}"
             class="text-wrap">
          {{ dateConverter(data.item.transaction.created_at, '/', true) }}
        </m-a>
      </template>

      <template #cell(action)="data">

        <b-btn pill variant="warning" v-b-modal="`edit-loan-${data.item.id}`"
               v-if="!isLoanPaid(data.item) && isUserHaveAccess"
               class="text-wrap mx-1">ویرایش
        </b-btn>

        <b-modal size="lg" :id="`edit-loan-${data.item.id}`" hide-footer>
          <div class="text-right" dir="rtl">
            <loan-create-form :order_id="$route.params.order" :item="data.item"/>
          </div>
        </b-modal>

        <b-btn pill v-b-modal="`pay-loan-${data.item.id}`"
               v-if="!isLoanPaid(data.item)"
               class="text-wrap mx-1">پرداخت
        </b-btn>

        <b-modal :id="`pay-loan-${data.item.id}`" hide-footer>
          <div class="text-right" dir="rtl">
            <b-form @submit.prevent="onSubmit(data.item)">


              <div class="my-3 py-3 bg-light">
                <h4>درگاه پرداخت</h4>

                <form-group class="my-3" :validations="$v.form.gateway">
                  <div slot-scope="{ errors, invalid }">
                    <b-form-group>

                      <!--                      <b-form-radio class="d-inline mx-2" v-if="checkMellatGate" v-model="form.gateway"
                                                          value="mellat"
                                                          name="payment-method">ملت
                                            </b-form-radio>-->
                      <b-form-radio class="d-inline mx-2" v-if="checkZarinpalGate" v-model="form.gateway"
                                    value="zarinpal"
                                    name="payment-method">زرین پال
                      </b-form-radio>
                      <b-form-radio class="d-inline mx-2" v-model="form.gateway"
                                    value="wallet"
                                    name="payment-method">کیف پول
                      </b-form-radio>

                      <template v-if="isUserHaveAccess">
                        <b-form-radio class="d-inline mx-2" v-model="form.gateway"
                                      value="cash"
                                      name="payment-method">نقد
                        </b-form-radio>

                        <b-form-radio class="d-inline mx-2" v-model="form.gateway"
                                      value="card"
                                      name="payment-method">کارت
                        </b-form-radio>
                      </template>

                      <form-errors-manager :errors="errors"/>

                    </b-form-group>
                  </div>
                </form-group>

              </div>


              <div class="mx-auto text-center">
                <b-btn pill type="submit" class="w-50 ">ثبت</b-btn>
              </div>


            </b-form>
          </div>
        </b-modal>

      </template>


    </b-table>

    <table class="table table-striped">
      <thead>
      <tr>
        <th scope="col">جمع اقساط</th>
        <th scope="col">پرداخت شده</th>
        <th scope="col">باقی مانده</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{ formatNumber(loanData.summary) }}</td>
        <td>{{ formatNumber(loanData.payed) }}</td>
        <td>{{ formatNumber(loanData.remaining) }}</td>
      </tr>
      </tbody>
    </table>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {required} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import LoanCreateForm from "./LoanCreateForm";

export default {
  name: "LoanItems",
  components: {FormErrorsManager, FormGroup, LoanCreateForm},
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "date_of_payment", label: "تاریخ قسط"},
        {key: "value", label: "مقدار"},
        {key: "transaction", label: "تاریخ پرداخت"},
        {key: "action", label: ""},
      ],
      form: {
        gateway: ''
      },
      user: {},
    };
  },
  computed: {
    ...mapGetters({
      loanItems: 'Loan/getLoanItems',
      isAdmin: 'User/isAdmin',
      isStore: 'User/isUserStore'
    }),
    isUserHaveAccess() {
      return this.isAdmin || this.isStore
    },
    loanData() {
      let loanData = {
        summary: 0,
        payed: 0,
        remaining: 0
      }

      this.loanItems.forEach(item => {

        let value = parseInt(item.value)

        loanData.summary += value
        if (item.transaction != null) {
          loanData.payed += value
        } else {
          loanData.remaining += value
        }

      })

      return loanData

    }
  },
  validations: {
    form: {
      gateway: {required}
    },
  },
  methods: {
    dateConverter,
    formatNumber,
    checkZarinpalGate() {
      return this.findAttributeOnSiteInfo('zarinpal_merchant_id')[0] !== '';
    },
    checkMellatGate() {
      return this.findAttributeOnSiteInfo('mellat_gate_info')[0] !== '';
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(item) {
      if (this.invalid()) {
        const form = {
          gateway: this.form.gateway,
          order_id: item.order_id,
          user_id: item.user_id,
          loan_id: item.id
        }
        this.$store.dispatch('Loan/payLoan', form)
      }
    },
    isLoanPaid(item) {
      return item.transaction != null && item.transaction.trans_id != null
    },
    getUserInformation() {
      const form = {
        user_id: this.$route.params.user,
      }
      this.$store.dispatch('User/getUserWithoutState', form).then(res => {
        this.user = res.data.data;
      })
    },
    manageLoanPrint() {
      window.print()
    }
  },
  async mounted() {
    const form = {
      user_id: this.$route.params.user,
      order_id: this.$route.params.order
    }
    await this.$store.dispatch('Loan/getLoanItems', form)


    await this.getUserInformation()
  }
}
</script>

<style scoped>

</style>